/*@ngInject*/
const ContentIframeDirective = function ($sce, $window) {

    let linkFunction = function ($scope, $elm, $attrs) {

        let iframe = $('.iframe'),
            iframeElem = $('.iframe')[0],
            contentIframe = $('.contentIframe');

        $scope.viewModel = {
            iframeSrc: $sce.trustAsResourceUrl($scope.iframeSrc),
            popoutUrl: $sce.trustAsResourceUrl($scope.popoutUrl),
            displayControls: !_.isUndefined($scope.displayControls) ? $scope.displayControls : true
        };

        $scope.refreshIframe = function () {
            iframeElem.src = $scope.viewModel.iframeSrc;
        };

        $scope.openExternal = function () {
            $window.open($scope.viewModel.popoutUrl, '_blank');
        };

        if ($scope.iframeSrc) {
            // For Internet Explorer, we need to manipulate the attribute
            // of the iframe directly to get it to display nicely.
            if (contentIframe.hasClass('ie')) {
                iframe.attr('height', '100%');
            }
        } else {
            // There is nothing to display in the iframe, so popout.
            $scope.openExternal();
            $scope.viewModel.displayControls = false;
        }
    };

    return {
        restrict: 'E',
        replace: true,
        templateUrl: '/content/externalContent/directives/contentIframe.tpl.html',
        link: linkFunction,
        scope: {
            iframeSrc: '<',
            popoutUrl: '<',
            displayControls: '<'
        }
    };
};

angular.module('gw-um-submission')
    .directive('contentIframe', ContentIframeDirective);
